const t = function() {
  return typeof fetch == "function";
};
export {
  t as canUseFetch
};
